import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { reactChildrenValidator } from '../../../validators/react-children';
import { defaultFilmContextAssets, filmContextAssetsValidator } from './assets';
import { defaultFilmContextConfig, filmContextConfigValidator } from './config';
import { defaultFilmContextDisplayText, filmContextDisplayTextValidator } from './display-text';
export const defaultFilmContextProps = {
    filmId: undefined,
    displayText: defaultFilmContextDisplayText,
    assets: defaultFilmContextAssets,
    config: defaultFilmContextConfig,
    children: undefined
};
export const filmContextPropsValidator = Validator.object({
    filmId: nonEmptyStringValidator,
    displayText: filmContextDisplayTextValidator,
    assets: filmContextAssetsValidator,
    config: filmContextConfigValidator,
    children: reactChildrenValidator
});
